module.exports = __webpack_public_path__ + "6ff1c0c9b3cf1b17732a5be48f076c67.png";